export const miniLanguages = [
    {
        text: "Arabic",
        code: "AR"
    },
    {
        text: "Bengali",
        code: "BN"
    },
    {
        text: "Bulgarian",
        code: "BG"
    },
    {
        text: "Canadian French",
        code: "FR-CA"
    },
    {
        text: "Chinese (Modern)",
        code: "ZH"
    },
    {
        text: "Chinese (Traditional)",
        code: "ZH-CHT"
    },
    {
        text: "Croatian",
        code: "HR"
    },
    {
        text: "Czech",
        code: "CS"
    },
    {
        text: "Danish",
        code: "DA"
    },
    {
        text: "Dutch",
        code: "NL"
    },
    {
        text: "English",
        code: "EN"
    },
    {
        text: "Estonian",
        code: "ET"
    },
    {
        text: "Finnish",
        code: "FI"
    },
    {
        text: "French",
        code: "FR"
    },
    {
        text: "German",
        code: "DE"
    },
    {
        text: "Greek",
        code: "EL"
    },
    {
        text: "Hebrew",
        code: "HE"
    },
    {
        text: "Hindi",
        code: "HI"
    },
    {
        text: "Hungarian",
        code: "HU"
    },
    {
        text: "Indonesian",
        code: "ID"
    },
    {
        text: "Italian",
        code: "IT"
    },
    {
        text: "Japanese",
        code: "JA"
    },
    {
        text: "Korean",
        code: "KO"
    },
    {
        text: "Latvian",
        code: "LV"
    },
    {
        text: "Lithuanian",
        code: "LT"
    },
    {
        text: "Malay",
        code: "MS"
    },
    {
        text: "Malayalam",
        code: "ML"
    },
    {
        text: "Mongolian",
        code: "MN"
    },
    {
        text: "Norwegian",
        code: "NO"
    },
    {
        text: "Polish",
        code: "PL"
    },
    {
        text: "Portuguese",
        code: "PT"
    },
    {
        text: "Portuguese (Brazil)",
        code: "PT-BR"
    },
    {
        text: "Romanian",
        code: "RO"
    },
    {
        text: "Russian",
        code: "RU"
    },
    {
        text: "Serbian",
        code: "SR"
    },
    {
        text: "Slovak",
        code: "SK"
    },
    {
        text: "Slovenian",
        code: "SL"
    },
    {
        text: "Spanish",
        code: "ES"
    },
    {
        text: "Spanish (Chilean)",
        code: "ES-CHL"
    },
    {
        text: "Spanish (Mexico)",
        code: "ES-MX"
    },
    {
        text: "Swedish",
        code: "SV"
    },
    {
        text: "Tagalog (Filipino)",
        code: "TL"
    },
    {
        text: "Tamil",
        code: "TA"
    },
    {
        text: "Thai",
        code: "TH"
    },
    {
        text: "Turkish",
        code: "TR"
    },
    {
        text: "Vietnamese",
        code: "VI"
    }
]

export const formatMini = [
    { text: "Regular Mini", code: "regular" },
    { text: "Ghs Mini", code: "ghs" }
]
